import * as React from 'react';

import StatusLabel from 'components/status-label/StatusLabel';

import { SUBCAMPAIGN_STATE_TO_LABEL_TYPE, isNegotiationsReopened, isRevoked } from 'utils/subcampaign';
import { t } from 'utils/language';

import type { StatusLabelSize, Subcampaign } from 'types';

type Props = {
  subcampaign: Subcampaign,
  size?: StatusLabelSize
};

export const SubcampaignState: React.FunctionComponent<Props> = (
  {
    subcampaign,
    size
  }: Props
) => {
  if (!subcampaign || !subcampaign.id) {
    return null;
  }

  const customSize = size || 'tiny';

  if (isRevoked(subcampaign)) {
    return (
      <StatusLabel
        size={customSize}
        label={t(`subcampaign_state_label_revoked_by_${String(subcampaign.revokedBy)}`)}
        type={SUBCAMPAIGN_STATE_TO_LABEL_TYPE.revoked}
      />
    );
  }

  if (isNegotiationsReopened(subcampaign)) {
    return (
      <StatusLabel
        size={customSize}
        label={t('negotiations_reopened_label')}
        type="warning"
      />
    );
  }

  return (
    <StatusLabel
      size={customSize}
      label={t(`subcampaign_state_label_${subcampaign.state}`)}
      type={SUBCAMPAIGN_STATE_TO_LABEL_TYPE[String(subcampaign.state)]}
    />
  );
};

export default SubcampaignState;
